export default "__VITE_ASSET__d49cf856__$_?nuxt_component=async__"